<bom-modal
  [title]="'GDPRModalHeader' | tekstresource"
  [isOpen$]="isGDPRModalOpen$"
  class="gdpr-modal"
>
  <ng-container bom-modal-content>
    <div [innerHtml]="'GDPRModalContent' | tekstresource"></div>
  </ng-container>
  <ng-container bom-modal-footer>
    <div [formGroup]="form" class="form-group">
      <input
        id="hideGDPR-checkbox"
        type="checkbox"
        name="checked"
        class="form-checkbox"
        formControlName="hideGDPRModal"
      /><label for="hideGDPR-checkbox">
        {{ 'GDPRModalHideInFuture' | tekstresource }}
      </label>
    </div>
  </ng-container>
</bom-modal>
